import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppV2 from './v2/AppV2';

/**
 * Punto de entrada único.
 *
 * 📌 Aquí había un switch por `REACT_APP_UI_VERSION` que elegía entre V1 y V2 con `import()`
 * dinámico. V1 se eliminó del repositorio, así que el switch sobraba — y peor: **la rama de V1 se
 * compilaba igual**. Webpack construye el grafo de módulos antes de minificar, así que las 20
 * pantallas viejas entraban al bundle de V2 en otro chunk, aunque nunca se cargaran.
 *
 * ⚠️ La variable `REACT_APP_UI_VERSION` ya no hace nada. Sigue puesta en el panel de DigitalOcean y
 * en el script `start:v2`; dejarla no rompe nada, pero conviene quitarla cuando se toque esa
 * configuración para que nadie la busque esperando que haga algo.
 *
 * Si hace falta recuperar V1, está en el historial de git: vivía en `src/Pages/`, con
 * `src/Components/Routing.tsx`, `src/App.tsx` y `src/Layout/`.
 */
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<AppV2 />);
